import Tag from '@/assets/icons/tag.svg';
import Icon from '@/components/elements/Icon/Icon';
import type { FullPlan } from '@/types/FullPlan';

export const ParseExchange = ({ on_market, off_market }: { on_market: FullPlan['on_market']; off_market: FullPlan['off_market'] }) => {
    const base = 'relative inline-flex items-center text-sm font-normal';

    if (on_market && off_market) {
        return (
            <div className="flex flex-col gap-2 items-end">
                <div className={`${base} text-[#0077DF]`}>
                    <Icon src={Tag} className="stroke-[#88C6F1] text-[#C0E0F7]" />
                    <span className="absolute right-2 text-sm">On-Exchange</span>
                </div>
                <div className={`${base} text-[#14A557]`}>
                    <Icon src={Tag} className="stroke-[#BAF8D6] text-[#F0FDF5]" />
                    <span className="absolute right-2 text-sm">Off-Exchange</span>
                </div>
            </div>
        );
    } else if (on_market) {
        return (
            <div className={`${base} text-[#0077DF]`}>
                <Icon src={Tag} className="stroke-[#88C6F1] text-[#C0E0F7]" />
                <span className="absolute right-2 text-sm">On-Exchange</span>
            </div>
        );
    } else if (off_market) {
        return (
            <div className={`${base} text-[#14A557]`}>
                <Icon src={Tag} className="stroke-[#BAF8D6] text-[#F0FDF5]" />
                <span className="absolute right-2 text-sm">Off-Exchange</span>
            </div>
        );
    }
    
    return null;
};

